import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { CurrentAccountState, HomeLocationState } from 'src/states';
import { NavigateToPatients, NavigateToPscSearch } from 'src/app/states/navigations.actions';
import { LocationAccountType } from 'src/app/enums/location-account-type.enum';

export const appDefaultNavigationGuard: CanActivateFn = () => {
  const store = inject(Store);
  const homeUserLocation = store.selectSnapshot(HomeLocationState.userLocation);
  const currentUserLocation = store.selectSnapshot(CurrentAccountState.userLocation);

  if (currentUserLocation) {
    store.dispatch(new NavigateToPatients());
    return false;
  }

  if (homeUserLocation?.accountType === LocationAccountType.PSC) {
    store.dispatch(new NavigateToPscSearch());
    return false;
  }

  return true;
};
